import InsightsWidget from './InsightsWidget'

export default InsightsWidget
